import { Heading } from '@acb_devel/design-system';

import styles from './ProfileCardTitle.module.scss';

export function ProfileCardTitle({ children }: { children: string }) {
  return (
    <Heading as="h3" variant="heading-1" className={styles.profileCardTitle}>
      {children}
    </Heading>
  );
}
